import { CSSProperties } from 'react';

type FileUploadHintProps = {
  maxFileSizeInMb: number;
  supportedFileTypes?: string[];
  style?: CSSProperties;
};

const FileUploadHint = ({
  supportedFileTypes,
  maxFileSizeInMb,
  style,
}: FileUploadHintProps) => {
  let message = null;

  if (supportedFileTypes && maxFileSizeInMb) {
    message = (
      <>
        File types: <strong>{supportedFileTypes.join(', ')}</strong>, up to{' '}
        <strong>{maxFileSizeInMb} Mb</strong>
      </>
    );
  } else {
    message = (
      <>
        File size limit: <strong>{maxFileSizeInMb} Mb</strong>
      </>
    );
  }

  return <p style={{ color: 'gray', ...style }}>{message}</p>;
};

export { FileUploadHint };
